export const getCopyExperimentParamsClient = (ipCountry, isMobile) => {
    const countries = !!ipCountry ? [String(ipCountry)] : undefined;
    const siteTypesArr = [];
    if (!isMobile)
        siteTypesArr.push("www");
    if (!!isMobile)
        siteTypesArr.push("mdot");
    const siteTypes = siteTypesArr.length ? siteTypesArr : undefined;
    return { countries, siteTypes };
};
